import React from 'react';
import { cn } from 'lib/utils';

export interface SettingsNavItem {
  id: string;
  label: string;
}

interface SettingsNavProps {
  items: SettingsNavItem[];
  activeId: string;
  onSelect: (id: string) => void;
  heading: string;
}

/** Presentational — the page owns the scroll-spy `activeId` and the scroll-to on select. */
export const SettingsNav: React.FC<SettingsNavProps> = ({ items, activeId, onSelect, heading }) => (
  <nav aria-label={heading} className="hidden w-[172px] shrink-0 lg:block">
    <div className="sticky top-2 space-y-1">
      <p className="px-3 pb-1 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground/70">
        {heading}
      </p>
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelect(item.id)}
          className={cn(
            'block w-full rounded-md px-3 py-1.5 text-left text-sm font-medium transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1',
            activeId === item.id
              ? 'bg-foreground text-background'
              : 'text-muted-foreground hover:bg-accent hover:text-foreground',
          )}
        >
          {item.label}
        </button>
      ))}
    </div>
  </nav>
);

export default SettingsNav;
